import styled, { css } from 'styled-components';

export const LabelStyle = css`
  
  padding: 16px 24px;
  font-size: ${props => props.theme.fonts.sizeButton};
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  
  
  text-align: center;
  vertical-align: middle;
  letter-spacing: -0.05px;
  width: auto;
  text-transform: uppercase;

  border-radius: 18px;
  
  line-height: 1.1;
  display: inline-flex;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
    padding: 2px;
  }

  div {
    white-space: nowrap;
  }
  
  ${props =>
    props.primary &&
    css`
      color: ${props => props.theme.colors.white};
      background: ${props => props.theme.colors.primary};
      border: 1px solid ${props => props.theme.colors.primary};
      transition: all 0.2s ease-in-out;

      use {
        fill: ${props => props.theme.colors.white};
      }
    `}

    ${props =>
      props.primaryInverted &&
      css`
        color: ${props => props.theme.colors.primary};
        background: ${props => props.theme.colors.white};
        border: 1px solid ${props => props.theme.colors.primary};
        transition: all 0.2s ease-in-out;

        use {
          fill: ${props => props.theme.colors.primary};
        }
      `}

      ${props =>
        props.neutral &&
        css`
          color: ${props => props.theme.colors.xDarkgray};
          border: 1px solid ${props => props.theme.colors.xDarkgray};
        `}
  ${props =>
    props.secondary &&
    css`
      color: ${props => props.theme.colors.black};
      background: ${props => props.theme.colors.secondary};
      border: 1px solid ${props => props.theme.colors.secondary};
      transition: all 0.2s ease-in-out;
    `}

    ${props =>
      props.secondaryInverted &&
      css`
        color: ${props => props.theme.colors.secondary};
        background: ${props => props.theme.colors.black};
        border: 1px solid ${props => props.theme.colors.secondary};
        transition: all 0.2s ease-in-out;
      `}
  
  ${props =>
    props.danger &&
    css`
      color: ${props => props.theme.colors.danger};
      background: ${props => props.theme.colors.white};
      border: 1px solid ${props => props.theme.colors.danger};
      transition: all 0.2s ease-in-out;

      use {
        fill: ${props => props.theme.colors.danger};
      }
    `}

    ${props =>
      props.success &&
      css`
        color: ${props => props.theme.colors.white};
        background: ${props => props.theme.colors.success};
        border: 1px solid ${props => props.theme.colors.success};
        transition: all 0.2s ease-in-out;
      `}


   ${props =>
     props.small &&
     css`
       padding: 8px 12px;
     `}

  ${props =>
    props.tiny &&
    css`
      padding: 5px 10px 4px;
    `}

  
  
    `;

const Label = styled.span`
  ${LabelStyle};
`;
export default Label;
